import React from 'react';
import css from './payroll.module.scss';
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import angular from "../../../assets/images/extra/angular.png";
import git from "../../../assets/images/extra/git.png";
import payroll from "../../../assets/images/projectsImage/Payroll.jpg";

const Payroll: React.FC = () => (
    <div className={css.project} id="payroll">
        <img src={payroll} alt=""/>
        <div className={css.projectInformationContainer}>
            <div className={css.projectName} style={{position: 'relative'}}>
                <h3>Payroll application</h3>
            </div>

            <div className={css.info}>
                <Chip label="2 Months" variant="outlined" size='small'/>
            </div>
            <div className={css.infoSmallScreen}>
                <Chip label="2 Months" variant="outlined" size='small'/>
            </div>

            <h5 className={css.textSectionInfo}>Description:</h5>
            <p className={css.description}>In this internship, I joined a dev team and I was asked to add some features
                and that was helpful to understand how front-end and angular applications works.</p>

            <h5 className={css.textSectionInfo}>Tasks:</h5>
            <ul className={css.tasks}>
                <li>Generate Reports in client side, using jsPDF library.</li>
                <li>Design and developing several app interfaces.</li>
            </ul>

            <h5 className={css.textSectionInfo}>Supervisor: <a className={css.link}
                                                               href='https://www.linkedin.com/in/taha-ben-salah/'
                                                               rel="noopener noreferrer"
                                                               target="_blank">Taha Ben Salah</a></h5>

            <h5 className={css.textSectionInfo}>Keywords:</h5>
            <div className={css.keywords}>
                <Tooltip title="ngxAdmin">
                    <Chip label="ngxAdmin" color="primary" variant="outlined" size='small'/>
                </Tooltip>
                <Tooltip title="jsPDF">
                    <Chip label="jsPDF" color="primary" variant="outlined" size='small'/>
                </Tooltip>
            </div>
            <div className={css.keywords}>
                <Tooltip title="Angular">
                    <img src={angular} alt=""/>
                </Tooltip>
                <Tooltip title="Git">
                    <img src={git} alt=""/>
                </Tooltip>
            </div>

        </div>
    </div>
);

export default Payroll;
